/* eslint-disable @typescript-eslint/no-unused-vars */
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { getEntityId } from 'helpers/entityId';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { EmployeeAvatarDropdown } from 'components/common/AvatarDropdown';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import CommentForm from 'components/common/CommentForm';
import CoverImage from '../board-view/CoverImage';
import DatePicker from 'components/base/DatePicker';
// import ReactSelect from 'components/base/ReactSelect';
import { JobComments } from 'components/common/JobComments';
// import EditableDetailsField from 'components/common/EditableDetailsField';
import {
  faMapLocation,
  // faPlus,
  faSquareCheck,
  faCamera
} from '@fortawesome/free-solid-svg-icons';
import {
  // ASSIGN_JOB,
  // Job,
  Job,
  JobComment,
  // JobComment,
  UPDATE_JOB_DESCRIPTION
} from 'services/api/job';
import { Employee } from 'data/users';
import FileUpload from 'components/forms/UploadForm';
import ImageUploadModal from 'components/modules/project-management/card-view/JobImageUploadModal';
import { useEffect, useState, useCallback } from 'react';
// import { UilUserPlus } from '@iconscout/react-unicons';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { GET_EMPLOYEES_QUERY } from 'services/api/employee';
import { formatDate } from 'helpers/utils';
import { GET_JOBS_QUERY } from 'services/api/job';
import { JobOption } from 'pages/apps/tasks/types/formFields';
import { BoardViewModalModalProps, EmployeeOption } from './types/types';
import { JobFileListItem } from '../todo-list/JobFiles';
import StickyComments from './StickyComments';
import {
  GET_STICKY_COMMENTS_BY_JOB,
  GET_COMMENTS_WITH_REPLIES_BY_JOB
} from 'services/api/comment';
import JobTasks from './JobTasks';
import { deleteFile } from 'services/api/file';

import toast from 'react-hot-toast';
import { useGlobalSocket } from 'hooks/useGlobalSocket';
import { useNotificationSocket } from 'hooks/useNotificationSocket';
import { useAccessToken } from 'providers/AccessTokenProvider';
import { useSharePointFiles } from 'hooks/useSharePointFiles';
import { Badge, Spinner } from 'react-bootstrap';
import { faCloud } from '@fortawesome/free-solid-svg-icons';

const CardViewModal = ({
  handleClose,
  show,
  project,
  canEditJob = false,
  canAddCommentsField = false,
  canAddShopCommentsField = false,
  canAddJobStageCommentsField = false,
  isLoadingTasks = false,
  jobTasks = [],
  comments,
  setComments,
  scrollToTasks = false,
  setScrollToTasks
}: BoardViewModalModalProps) => {
  const user = JSON.parse(localStorage.getItem('authUser') as string);
  const { authUser } = useAccessToken();
  const [hasUpdated, setHasUpdated] = useState<boolean>(false);
  // const [showEmployeeDropdown, setShowEmployeeDropdown] =
  //   useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [employeeOptions, setEmployeeOptions] = useState<EmployeeOption[]>([]);
  const [selectedEmployees, setSelectedEmployees] = useState<EmployeeOption[]>(
    []
  );
  const [showTaskModal, setShowTaskModal] = useState<boolean>(false);
  const [showImageModal, setShowImageModal] = useState<boolean>(false);
  const [modalComments, setModalComments] = useState<JobComment[]>([]);
  const [socketConnected, setSocketConnected] = useState<boolean>(false);
  const queries = useQueryClient();

  const projectId = (project?.id || project?._id) as string;

  const jobNumbers = project?.jobNumber ? [project.jobNumber] : [];
  const companyNames = project?.customer?.organizationName
    ? [project.customer.organizationName]
    : [];

  const { data: sharePointFiles, isLoading: isLoadingSharePoint } =
    useSharePointFiles({
      jobNumbers,
      companyNames,
      enabled: show
    });

  const allDisplayFiles = [
    ...(project?.files || []).map(f => ({ ...f, source: 'gcp' })),
    ...(sharePointFiles || []).map((file: any) => ({
      id: file.id,
      fileName: file.name,
      mimeType: file.fileType,
      fileUrl: file.webUrl,
      creator: {
        _id: file.createdBy.user.id || 'sharepoint_user',
        firstName: file.createdBy.user.displayName.split(' ')[0] || '',
        lastName:
          file.createdBy.user.displayName.split(' ').slice(1).join(' ') || '',
        username: file.createdBy.user.email,
        email: file.createdBy.user.email,
        verified: true
      } as Employee,
      size: file.size.toString(),
      createdAt: file.lastModifiedDateTime,
      source: 'sharepoint',
      jobId: projectId || ''
    }))
  ];

  const { data: fetchedComments, refetch: refetchModalComments } = useQuery(
    ['jobComments', projectId],
    () => GET_COMMENTS_WITH_REPLIES_BY_JOB(projectId as string),
    {
      enabled: !!projectId,
      staleTime: 30 * 1000,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      onSuccess: data => {
        if (data?.data && Array.isArray(data.data)) {
          const sortedComments = [...data.data].sort(
            (a, b) =>
              new Date(b.createdAt || 0).getTime() -
              new Date(a.createdAt || 0).getTime()
          );
          setModalComments(sortedComments);
        }
      }
    }
  );

  const currentComments =
    fetchedComments?.data || modalComments || comments || [];

  // Monitor socket connection status
  const socket = useGlobalSocket({
    enabled: Boolean(authUser),
    jobId: show ? projectId : undefined, // Only connect when modal is open

    onTaskCreated: useCallback(
      (taskData: any) => {
        console.log('📋 Task created via socket in CardViewModal:', taskData);
        if (taskData.jobId === projectId) {
          queries.invalidateQueries(['jobTasks', projectId]);
          queries.invalidateQueries(['tasks']);
          queries.invalidateQueries(['filteredTasks']);
        }
      },
      [projectId, queries]
    ),

    onTaskUpdated: useCallback(
      (taskData: any) => {
        console.log('📋 Task updated via socket in CardViewModal:', taskData);
        if (taskData.jobId === projectId) {
          queries.invalidateQueries(['jobTasks', projectId]);
          queries.invalidateQueries(['tasks']);
          queries.invalidateQueries(['filteredTasks']);
        }
      },
      [projectId, queries]
    ),

    onCommentCreated: useCallback(
      (newComment: JobComment) => {
        console.log(
          '💬 CardViewModal: Comment created -',
          newComment.id || newComment._id
        );
        if (newComment.jobId === projectId && show) {
          // Immediate state update to prevent UI lag
          setModalComments(prevComments => {
            const newCommentId = newComment.id || newComment._id;
            const exists = prevComments.some(
              (c: JobComment) => (c.id || c._id) === newCommentId
            );
            if (exists) return prevComments;

            const updated = [newComment, ...prevComments].sort(
              (a: JobComment, b: JobComment) =>
                new Date(b.createdAt || 0).getTime() -
                new Date(a.createdAt || 0).getTime()
            );
            console.log(
              '💬 Updated modal comments immediately with new comment'
            );
            return updated;
          });

          // Background refetch for data consistency
          setTimeout(() => refetchModalComments(), 100);
          queries.invalidateQueries('getJobs');
          if (newComment.isSticky) {
            queries.invalidateQueries(['stickyComments', projectId]);
          }
        }
      },
      [projectId, show, refetchModalComments, queries]
    ),

    onCommentReplyCreated: useCallback(
      (newReply: JobComment) => {
        console.log('💬 CardViewModal: Reply created -', {
          replyId: newReply.id || newReply._id,
          parentId: newReply.parentCommentId,
          jobId: newReply.jobId,
          modalOpen: show,
          currentJobId: projectId
        });

        if (newReply.jobId === projectId && show) {
          // Immediate state update - add reply to the correct parent comment
          setModalComments(prevComments => {
            const addReplyToComment = (
              comments: JobComment[]
            ): JobComment[] => {
              return comments.map((comment: JobComment) => {
                if ((comment.id || comment._id) === newReply.parentCommentId) {
                  const newReplyId = newReply.id || newReply._id;
                  const existingReply = comment.replies?.some(
                    (r: JobComment) => (r.id || r._id) === newReplyId
                  );
                  if (existingReply) return comment;

                  const updatedComment = {
                    ...comment,
                    replies: [...(comment.replies || []), newReply].sort(
                      (a: JobComment, b: JobComment) =>
                        new Date(a.createdAt || 0).getTime() -
                        new Date(b.createdAt || 0).getTime()
                    )
                  };
                  console.log('💬 Added reply to parent comment immediately');
                  return updatedComment;
                }

                if (comment.replies && comment.replies.length > 0) {
                  return {
                    ...comment,
                    replies: addReplyToComment(comment.replies)
                  };
                }

                return comment;
              });
            };

            return addReplyToComment(prevComments);
          });

          // Background refetch for data consistency
          setTimeout(() => refetchModalComments(), 100);
          queries.invalidateQueries('getJobs');
        }
      },
      [projectId, show, refetchModalComments, queries]
    ),

    onCommentPinUpdated: useCallback(
      (updatedComment: JobComment) => {
        console.log(
          '📌 CardViewModal: Comment pin updated -',
          updatedComment.id || updatedComment._id
        );
        if (updatedComment.jobId === projectId && show) {
          // Immediate state update
          setModalComments(prevComments =>
            prevComments.map((comment: JobComment) =>
              (comment.id || comment._id) ===
              (updatedComment.id || updatedComment._id)
                ? { ...comment, isSticky: updatedComment.isSticky }
                : comment
            )
          );

          setTimeout(() => refetchModalComments(), 100);
          queries.invalidateQueries('getJobs');
          queries.invalidateQueries(['stickyComments', projectId]);
        }
      },
      [projectId, show, refetchModalComments, queries]
    ),

    onCommentDeleted: useCallback(
      (data: { commentId: string; jobId: string }) => {
        console.log('🗑️ CardViewModal: Comment deleted -', data.commentId);
        if (data.jobId === projectId && show) {
          // Immediate state update - remove comment/reply
          setModalComments(prevComments => {
            const removeComment = (comments: JobComment[]): JobComment[] => {
              return comments
                .filter(
                  (comment: JobComment) =>
                    (comment.id || comment._id) !== data.commentId
                )
                .map((comment: JobComment) => ({
                  ...comment,
                  replies: comment.replies ? removeComment(comment.replies) : []
                }));
            };

            return removeComment(prevComments);
          });

          setTimeout(() => refetchModalComments(), 100);
          queries.invalidateQueries('getJobs');
          queries.invalidateQueries(['stickyComments', projectId]);
        }
      },
      [projectId, show, refetchModalComments, queries]
    )
  });

  // Monitor socket connection status for production debugging
  useEffect(() => {
    if (socket) {
      const handleConnect = () => {
        setSocketConnected(true);
        console.log('✅ Socket connected in CardViewModal');
      };

      const handleDisconnect = () => {
        setSocketConnected(false);
        console.warn('❌ Socket disconnected in CardViewModal');

        // Force refetch after disconnection to catch missed events
        if (show && projectId) {
          console.log('🔄 Refetching due to socket disconnection');
          setTimeout(() => refetchModalComments(), 2000);
        }
      };

      socket.on('connect', handleConnect);
      socket.on('disconnect', handleDisconnect);

      // Check initial connection status
      if (socket.connected) {
        setSocketConnected(true);
      }

      return () => {
        socket.off('connect', handleConnect);
        socket.off('disconnect', handleDisconnect);
      };
    }
  }, [socket, show, projectId, refetchModalComments]);

  useNotificationSocket({
    enabled: Boolean(authUser),
    onNewNotification: notification => {
      console.log('New notification received in CardViewModal:', notification);
      queries.invalidateQueries(['notifications']);
    },
    onNotificationCountUpdate: data => {
      queries.setQueryData(['notificationCount'], () => ({
        data: { count: data.count }
      }));
    }
  });

  const {
    data: employee,
    isLoading,
    isFetched
  } = useQuery('get_all_employees', GET_EMPLOYEES_QUERY, {
    staleTime: 3 * 60 * 60 * 1000
  });

  const { data: employees } = useQuery(
    'get_all_employees_for_modal_task',
    GET_EMPLOYEES_QUERY,
    {
      staleTime: 3 * 60 * 60 * 1000,
      enabled: showTaskModal,
      select: (response: any) => {
        return response.data.map((employee: any) => ({
          value: getEntityId(employee) || '',
          label: `${employee.firstName} ${employee.lastName}`
        }));
      }
    }
  );

  const { data: jobs } = useQuery('get_jobs_for_modal_task', GET_JOBS_QUERY, {
    staleTime: 3 * 60 * 60 * 1000,
    enabled: showTaskModal,
    select: () => {
      const jobOption: JobOption = {
        value: projectId as string,
        label: project.title,
        well: project.well,
        location:
          typeof project.location === 'string'
            ? project.location
            : project.location?.location,
        customer: project.customer?.organizationName || '',
        jobNumber: project.jobNumber || ''
      };
      return [jobOption];
    }
  });

  const { data: stickyComments = [] } = useQuery(
    ['stickyComments', projectId],
    () => GET_STICKY_COMMENTS_BY_JOB(projectId as string),
    {
      enabled: !!projectId,
      staleTime: 5 * 60 * 1000,
      select: data => data?.data || []
    }
  );

  const handleTaskModalClose = () => {
    if (projectId) {
      queries.invalidateQueries(['jobTasks', projectId]);
    }
  };

  useEffect(() => {
    if (hasUpdated) {
      queries.invalidateQueries('getJobs');
      setHasUpdated(false);
    }
  }, [hasUpdated, queries]);

  useEffect(() => {
    if (show && projectId) {
      queries.invalidateQueries(['jobTasks', projectId]);
      // Force refetch comments when modal opens to ensure latest data
      refetchModalComments();
      console.log('🎯 Modal opened - refetching comments');
    }
  }, [show, projectId, queries, refetchModalComments]);

  // Clear modal comments when modal closes to ensure fresh data on next open
  useEffect(() => {
    if (!show) {
      setModalComments([]);
    }
  }, [show]);

  // Periodic refetching during active conversations (fallback for missed WebSocket events)
  useEffect(() => {
    if (!show || !projectId) return;

    const intervalId = setInterval(() => {
      // Only refetch if modal is open and there are comments (active conversation)
      if (show && (modalComments.length > 0 || currentComments.length > 0)) {
        console.log('🔄 Periodic refetch during active conversation');
        refetchModalComments();
      }
    }, 15000); // Refetch every 15 seconds during active conversations

    return () => clearInterval(intervalId);
  }, [
    show,
    projectId,
    modalComments.length,
    currentComments.length,
    refetchModalComments
  ]);

  // Debug logging for production troubleshooting
  useEffect(() => {
    if (show) {
      console.log('🎯 CardViewModal State Debug:', {
        jobId: projectId,
        modalCommentsLength: modalComments.length,
        currentCommentsLength: currentComments.length,
        socketConnected,
        show,
        timestamp: new Date().toISOString()
      });
    }
  }, [
    modalComments.length,
    currentComments.length,
    socketConnected,
    show,
    projectId
  ]);

  useEffect(() => {
    if (isFetched && !isLoading && project) {
      const assignedEmployeeIds = new Set(
        project.assignedTo.map(emp => getEntityId(emp))
      );

      const options = (employee?.data || [])
        .filter(emp => !assignedEmployeeIds.has(getEntityId(emp)))
        .map((emp: Employee) => ({
          value: getEntityId(emp) || '',
          label: `${emp.firstName} ${emp.lastName}`
        }));

      setEmployeeOptions(options);
    }
  }, [isLoading, isFetched, employee, project]);

  const allowedDetails = [
    'departureDate',
    'destinationType',
    'well',
    'jobNumber',
    'leavingFrom',
    'expectedEquipmentShipDate',
    'returnDate'
  ];
  // const handleEmployeeChange = (
  //   selectedOptions: EmployeeOption[] | null | unknown
  // ) => {
  //   setSelectedEmployees(selectedOptions as EmployeeOption[]);
  // };
  // const handleAssignToEmployees = () => {
  //   setShowEmployeeDropdown(false);
  //   assignJob.mutateAsync({
  //     id: String(projectId),
  //     userIds: selectedEmployees.map(emp => emp.value)
  //   });
  // };
  const updateDescriptionMutation = useMutation(
    'updateDescription',
    UPDATE_JOB_DESCRIPTION,
    {
      onSuccess: () => {
        queries.invalidateQueries('getJobs');
        setSelectedEmployees([]);
      },
      onError: (error: TypeError) => {
        setError(error.message);
      }
    }
  );
  const updateDescription = (value: string) => {
    updateDescriptionMutation.mutateAsync({
      formData: { description: value },
      jobId: String(projectId)
    });
  };
  const renderJobInfo = () => {
    const orderedFields = [
      'well',
      'jobNumber',
      ...allowedDetails.filter(
        field => field !== 'well' && field !== 'jobNumber'
      )
    ];

    return orderedFields.map(key => {
      const typedKey = key as keyof Job;
      if (allowedDetails.includes(key) && project && typedKey in project) {
        const value = project[typedKey];
        return (
          <Button
            key={key}
            variant="soft-secondary"
            startIcon={
              <FontAwesomeIcon icon={faSquareCheck} className="me-2" />
            }
            className="w-100 text-start"
            size="sm"
          >
            <span className="text-700">
              {improvedCamelToSentenceCase(key)}:
            </span>
            <br />
            {key === 'departureDate' ||
            key === 'expectedEquipmentShipDate' ||
            key === 'returnDate'
              ? formatDate(value as Date)
              : String(value)}
          </Button>
        );
      }
      return null;
    });
  };
  const renderJobInfoObject = () => {
    return (
      <>
        <Button
          variant="soft-secondary"
          startIcon={<FontAwesomeIcon icon={faSquareCheck} className="me-2" />}
          className="w-100 text-start"
          size="sm"
        >
          <span className="text-700">Rig:</span>
          <br />
          {project?.rig?.name}
        </Button>
        <Button
          variant="soft-secondary"
          startIcon={<FontAwesomeIcon icon={'tank-water'} className="me-2" />}
          className="w-100 text-start"
          size="sm"
        >
          <span className="text-700">Stage:</span>
          <br />
          {project?.jobStage?.name}
        </Button>
        <Button
          variant="soft-secondary"
          startIcon={<FontAwesomeIcon icon={faSquareCheck} className="me-2" />}
          className="w-100 text-start"
          size="sm"
        >
          <span className="text-700">Type:</span>
          <br />
          {project?.jobType?.name}
        </Button>
      </>
    );
  };
  function improvedCamelToSentenceCase(str: string): string {
    return str
      .replace(/([A-Z])/g, ' $1') // Add space before uppercase letters
      .replace(/^./, match => match.toUpperCase()) // Capitalize first letter
      .replace(/([a-z])([A-Z])/g, (_, p1, p2) => `${p1} ${p2.toLowerCase()}`) // Handle mid-word capitals
      .trim(); // Remove leading/trailing spaces
  }

  const handleDeleteFile = async (fileId: string) => {
    try {
      await deleteFile(fileId);
      queries.invalidateQueries('getJobs');
      toast.success('File deleted successfully');
    } catch (error: any) {
      console.error('Failed to delete file:', error);
      toast.error(error.message || 'Failed to delete file');
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="lg" className="p-0">
        <Modal.Header className="position-relative p-0 overflow-hidden">
          <CoverImage
            handleClose={handleClose}
            id={projectId}
            imageUrl={project?.customer?.companyLogoUrl}
            canEditJob={canEditJob}
          />
        </Modal.Header>
        <Modal.Body className="p-5 px-md-6 pb-md-6">
          {/* <ActionSection /> */}
          <Row className="g-5">
            <Col xs={12} xl={9}>
              <div className="mb-4">
                <h3 className="fw-bolder lh-sm">{project?.title}</h3>
                <p className="text-1000 fw-semi-bold mb-0">
                  Rig Info: {project?.rig?.name}
                  <Link className="ms-1 fw-bold" to="#!">
                    Supervisor: {project?.supervisor[0]?.lastName}{' '}
                    {project?.supervisor[0]?.firstName}
                  </Link>
                </p>
              </div>

              <Row>
                <Col xs={12} md={12}>
                  <Row>
                    <Col md={6}>
                      <h6 className="text-800 mb-2">Customer</h6>
                      <div className="mb-3">
                        <div className="w-100">
                          <Form.Control
                            defaultValue={project?.customer?.organizationName}
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <h6 className="text-800 mb-2">Customer Rep</h6>
                      <div className="mb-3">
                        <div className="w-100">
                          <Form.Control
                            defaultValue={`${project?.customerRepresentative?.firstName} ${project?.customerRepresentative?.lastName}`}
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} md={12}>
                  <Row>
                    <Col md={6}>
                      <h6 className="text-800 mb-2">
                        Expected Return Operator Date
                      </h6>
                      <div className="mb-3">
                        <div className="w-100">
                          <DatePicker
                            placeholder="Set the due date"
                            options={{
                              defaultDate: `${project?.returnDate}`
                            }}
                            value={project?.returnDate}
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <h6 className="text-800 mb-2">Expected Departure Date</h6>
                      <div className="mb-3">
                        <div className="w-100">
                          <DatePicker
                            placeholder="Set the due date"
                            options={{
                              defaultDate: `${project?.departureDate}`
                            }}
                            value={project?.departureDate}
                            disabled
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* <div className="mb-3">
                <h6 className="text-800 mb-2">Assignees</h6>
                <div className="d-flex gap-1">
                  {project?.assignedTo.slice(0, 5).map((member: Employee) => (
                    <EmployeeAvatarDropdown
                      user={member}
                      jobId={projectId}
                      supervisorId={getEntityId(project?.supervisor[0])}
                      size="m"
                      key={getEntityId(member)}
                    />
                  ))}
                  {project.supervisor.find(
                    employee => getEntityId(employee) === getEntityId(user)
                  ) && (
                    <Button
                      variant="phoenix-secondary"
                      className="btn-circle"
                      size="sm"
                      onClick={() =>
                        setShowEmployeeDropdown(!showEmployeeDropdown)
                      }
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  )}
                </div>
                {showEmployeeDropdown && (
                  <Col xs={12}>
                    <div className="mb-3 mt-5">
                      <ReactSelect
                        options={employeeOptions}
                        className="mb-5"
                        isMulti
                        name="assignedTo"
                        value={selectedEmployees}
                        onChange={handleEmployeeChange}
                        placeholder="Select Employee"
                        icon={
                          <UilUserPlus
                            className="react-select-icon text-700"
                            size={16}
                          />
                        }
                      />
                    </div>
                    <Button
                      onClick={handleAssignToEmployees}
                      variant="phoenix-primary"
                      className="px-6 ms-auto"
                    >
                      Assign
                    </Button>
                    {assignJob.isError && <div>{error}</div>}
                  </Col>
                )}
              </div> */}
              {/* {project.supervisor.find(
                employee => getEntityId(employee) === getEntityId(user)
              ) ? (
                <EditableDetailsField
                  onSave={updateDescription}
                  className="mb-6"
                >
                  {project.description}
                </EditableDetailsField>
              ) : (
                <>{project.description}</>
              )} */}

              <div className="bg-100 rounded-2 px-4 pt-2 mb-3">
                {/* Sticky Comments Section */}
                {stickyComments && stickyComments.length > 0 && (
                  <StickyComments
                    stickyComments={stickyComments}
                    userId={getEntityId(user) || ''}
                    isPriority={project?.isPriority}
                  />
                )}

                {/* All Comments Section */}
                <div className="mb-1">
                  <JobComments
                    comments={currentComments || []}
                    className={'mb-1'}
                    jobId={projectId}
                  />
                </div>
              </div>
              <div className="pb-3 border-bottom mb-6">
                <CommentForm
                  job={project}
                  setHasUpdated={setHasUpdated}
                  canAddCommentsField={canAddCommentsField}
                  canAddShopCommentsField={canAddShopCommentsField}
                  canAddJobStageCommentsField={canAddJobStageCommentsField}
                />
              </div>

              <JobTasks
                isLoadingTasks={isLoadingTasks}
                jobTasks={jobTasks}
                scrollToTasks={scrollToTasks}
                setScrollToTasks={setScrollToTasks}
                showTaskModal={showTaskModal}
                setShowTaskModal={setShowTaskModal}
                employees={employees || []}
                jobs={jobs || []}
                onTaskModalClose={handleTaskModalClose}
              />

              <div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <h4 className="mb-0">Files</h4>
                    {isLoadingSharePoint && (
                      <div className="text-muted fs-10">
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-1"
                        />
                        Syncing...
                      </div>
                    )}
                  </div>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setShowImageModal(true)}
                    className="px-3"
                  >
                    <FontAwesomeIcon icon={faCamera} className="me-1" />
                    Add Images
                  </Button>
                </div>
                <div
                  className="file-list-container mb-3"
                  style={{
                    maxHeight: '400px',
                    overflowY: 'auto',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none'
                  }}
                >
                  <style>
                    {`
                      .file-list-container::-webkit-scrollbar {
                        display: none;
                      }
                    `}
                  </style>
                  {allDisplayFiles.map((attachment, index) => (
                    <div key={attachment.id} className="position-relative">
                      <JobFileListItem
                        attachment={attachment}
                        className={classNames({
                          'border-top': index === 0
                        })}
                        onDeleteFile={
                          attachment.source === 'gcp'
                            ? handleDeleteFile
                            : undefined
                        }
                      />
                      {attachment.source === 'sharepoint' && (
                        <div
                          className="position-absolute top-0 end-0 mt-3 me-2"
                          title="Stored in SharePoint"
                        >
                          <Badge bg="info" className="fs-10">
                            <FontAwesomeIcon icon={faCloud} className="me-1" />
                            SP
                          </Badge>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <div className="">
                  <FileUpload
                    setHasUpdated={setHasUpdated}
                    jobId={projectId as string}
                    files={project?.files}
                    multiple={true}
                    jobNumbers={project?.jobNumber ? [project.jobNumber] : []}
                    companyNames={
                      project?.customer?.organizationName
                        ? [project.customer.organizationName]
                        : []
                    }
                  />
                </div>
              </div>
            </Col>

            <Col xs={12} xl={3}>
              <h5 className="text-800 mb-3">Job Information</h5>
              <div className="mb-6 d-flex flex-column gap-2">
                <Button
                  variant="soft-secondary"
                  startIcon={
                    <FontAwesomeIcon icon={faMapLocation} className="me-2" />
                  }
                  className="w-100 text-start"
                  size="sm"
                >
                  <span className="text-700">Location:</span>
                  <br />
                  {project?.location?.location}
                </Button>
                <>{renderJobInfo()}</>
                <>{renderJobInfoObject()}</>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      {/* Image Upload Modal */}
      <ImageUploadModal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        jobId={projectId as string}
        files={project?.files || []}
        setHasUpdated={setHasUpdated}
        onDeleteFile={handleDeleteFile}
        jobNumbers={project?.jobNumber ? [project.jobNumber] : []}
        companyNames={
          project?.customer?.organizationName
            ? [project.customer.organizationName]
            : []
        }
      />
    </>
  );
};

export default CardViewModal;
